import * as Types from './graphql/hirer-types.generated';

import { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ApplicationsFacetsQueryVariables = Types.Exact<{
  applicationsFacetsInput: Types.ApplicationsFacetsInput;
  descriptionInput: Types.LocationDescriptionInput;
  displayDescriptionInput: Types.LocationDisplayDescriptionInput;
  candidateProfileNationalityInput: Types.CandidateProfileNationalityCountryNameInput;
  canShowNationalityFilter: Types.Scalars['Boolean']['input'];
}>;

export type ApplicationsFacetsQuery = {
  __typename: 'Query';
  applicationsFacets:
    | {
        __typename: 'ApplicationsFacetsResponseSuccess';
        result: {
          __typename: 'ApplicationsFacetsResult';
          preQuestionnaireFilterTotal: number;
          homeLocationFacets: Array<{
            __typename: 'ApplicationsFacetsResultHomeLocationFacet';
            count: number;
            homeLocation: {
              __typename: 'Location';
              id: string;
              description: string;
              displayDescription: string;
              isSeekMarketCountry: boolean;
              country: string;
            };
            children: Array<{
              __typename: 'ApplicationsFacetsResultHomeLocationFacet';
              count: number;
              homeLocation: {
                __typename: 'Location';
                id: string;
                description: string;
                displayDescription: string;
                isSeekMarketCountry: boolean;
                country: string;
              };
              children: Array<{
                __typename: 'ApplicationsFacetsResultHomeLocationFacet';
                count: number;
                homeLocation: {
                  __typename: 'Location';
                  id: string;
                  description: string;
                  displayDescription: string;
                  isSeekMarketCountry: boolean;
                  country: string;
                };
                children: Array<{
                  __typename: 'ApplicationsFacetsResultHomeLocationFacet';
                  count: number;
                  homeLocation: {
                    __typename: 'Location';
                    id: string;
                    description: string;
                    displayDescription: string;
                    isSeekMarketCountry: boolean;
                    country: string;
                  };
                  children: Array<{
                    __typename: 'ApplicationsFacetsResultHomeLocationFacet';
                    count: number;
                    homeLocation: {
                      __typename: 'Location';
                      id: string;
                      description: string;
                      displayDescription: string;
                      isSeekMarketCountry: boolean;
                      country: string;
                    };
                    children: Array<{
                      __typename: 'ApplicationsFacetsResultHomeLocationFacet';
                      count: number;
                      homeLocation: {
                        __typename: 'Location';
                        id: string;
                        description: string;
                        displayDescription: string;
                        isSeekMarketCountry: boolean;
                        country: string;
                      };
                    }>;
                  }>;
                }>;
              }>;
            }>;
          }>;
          nationalityFacets?: Array<{
            __typename: 'ApplicationsFacetsResultNationalityFacet';
            count: number;
            nationality:
              | {
                  __typename: 'ApplicationProfileNotSpecifiedNationality';
                  id: string;
                  countryName: string;
                }
              | {
                  __typename: 'CandidateProfileNationality';
                  id: string;
                  countryName: string;
                };
          }>;
          statusFacets: {
            __typename: 'ApplicationFacetsResultStatusFacet';
            inboxCount: number;
            prescreenCount: number;
            shortlistCount: number;
            interviewCount: number;
            offerCount: number;
            acceptCount: number;
            rejectedCount: number;
            newCount: number;
            totalCount: number;
          };
          questionnaireAnswerFacets: Array<{
            __typename: 'ApplicationsFacetsResultQuestionnaireAnswerFacet';
            id: string;
            count: number;
          }>;
        };
      }
    | { __typename: 'ResponseError'; error: Types.ResponseErrorReason };
};

export const ApplicationsFacetsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ApplicationsFacets' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'applicationsFacetsInput' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ApplicationsFacetsInput' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'descriptionInput' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LocationDescriptionInput' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'displayDescriptionInput' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'LocationDisplayDescriptionInput' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'candidateProfileNationalityInput' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: {
                kind: 'Name',
                value: 'CandidateProfileNationalityCountryNameInput',
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'canShowNationalityFilter' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'Boolean' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationsFacets' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'applicationsFacetsInput' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: {
                      kind: 'Name',
                      value: 'ApplicationsFacetsResponseSuccess',
                    },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'result' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'homeLocationFacets',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'homeLocation',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'id' },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'description',
                                          },
                                          arguments: [
                                            {
                                              kind: 'Argument',
                                              name: {
                                                kind: 'Name',
                                                value: 'input',
                                              },
                                              value: {
                                                kind: 'Variable',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'descriptionInput',
                                                },
                                              },
                                            },
                                          ],
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'displayDescription',
                                          },
                                          arguments: [
                                            {
                                              kind: 'Argument',
                                              name: {
                                                kind: 'Name',
                                                value: 'input',
                                              },
                                              value: {
                                                kind: 'Variable',
                                                name: {
                                                  kind: 'Name',
                                                  value:
                                                    'displayDescriptionInput',
                                                },
                                              },
                                            },
                                          ],
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'isSeekMarketCountry',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'country',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'count' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'children' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'homeLocation',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'id',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'description',
                                                },
                                                arguments: [
                                                  {
                                                    kind: 'Argument',
                                                    name: {
                                                      kind: 'Name',
                                                      value: 'input',
                                                    },
                                                    value: {
                                                      kind: 'Variable',
                                                      name: {
                                                        kind: 'Name',
                                                        value:
                                                          'descriptionInput',
                                                      },
                                                    },
                                                  },
                                                ],
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'displayDescription',
                                                },
                                                arguments: [
                                                  {
                                                    kind: 'Argument',
                                                    name: {
                                                      kind: 'Name',
                                                      value: 'input',
                                                    },
                                                    value: {
                                                      kind: 'Variable',
                                                      name: {
                                                        kind: 'Name',
                                                        value:
                                                          'displayDescriptionInput',
                                                      },
                                                    },
                                                  },
                                                ],
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'isSeekMarketCountry',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'country',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'count',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'children',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'homeLocation',
                                                },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'id',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'description',
                                                      },
                                                      arguments: [
                                                        {
                                                          kind: 'Argument',
                                                          name: {
                                                            kind: 'Name',
                                                            value: 'input',
                                                          },
                                                          value: {
                                                            kind: 'Variable',
                                                            name: {
                                                              kind: 'Name',
                                                              value:
                                                                'descriptionInput',
                                                            },
                                                          },
                                                        },
                                                      ],
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value:
                                                          'displayDescription',
                                                      },
                                                      arguments: [
                                                        {
                                                          kind: 'Argument',
                                                          name: {
                                                            kind: 'Name',
                                                            value: 'input',
                                                          },
                                                          value: {
                                                            kind: 'Variable',
                                                            name: {
                                                              kind: 'Name',
                                                              value:
                                                                'displayDescriptionInput',
                                                            },
                                                          },
                                                        },
                                                      ],
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value:
                                                          'isSeekMarketCountry',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'country',
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'count',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'children',
                                                },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'homeLocation',
                                                      },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'Field',
                                                            name: {
                                                              kind: 'Name',
                                                              value: 'id',
                                                            },
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: {
                                                              kind: 'Name',
                                                              value:
                                                                'description',
                                                            },
                                                            arguments: [
                                                              {
                                                                kind: 'Argument',
                                                                name: {
                                                                  kind: 'Name',
                                                                  value:
                                                                    'input',
                                                                },
                                                                value: {
                                                                  kind: 'Variable',
                                                                  name: {
                                                                    kind: 'Name',
                                                                    value:
                                                                      'descriptionInput',
                                                                  },
                                                                },
                                                              },
                                                            ],
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: {
                                                              kind: 'Name',
                                                              value:
                                                                'displayDescription',
                                                            },
                                                            arguments: [
                                                              {
                                                                kind: 'Argument',
                                                                name: {
                                                                  kind: 'Name',
                                                                  value:
                                                                    'input',
                                                                },
                                                                value: {
                                                                  kind: 'Variable',
                                                                  name: {
                                                                    kind: 'Name',
                                                                    value:
                                                                      'displayDescriptionInput',
                                                                  },
                                                                },
                                                              },
                                                            ],
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: {
                                                              kind: 'Name',
                                                              value:
                                                                'isSeekMarketCountry',
                                                            },
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: {
                                                              kind: 'Name',
                                                              value: 'country',
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'count',
                                                      },
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: {
                                                        kind: 'Name',
                                                        value: 'children',
                                                      },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'Field',
                                                            name: {
                                                              kind: 'Name',
                                                              value:
                                                                'homeLocation',
                                                            },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                {
                                                                  kind: 'Field',
                                                                  name: {
                                                                    kind: 'Name',
                                                                    value: 'id',
                                                                  },
                                                                },
                                                                {
                                                                  kind: 'Field',
                                                                  name: {
                                                                    kind: 'Name',
                                                                    value:
                                                                      'description',
                                                                  },
                                                                  arguments: [
                                                                    {
                                                                      kind: 'Argument',
                                                                      name: {
                                                                        kind: 'Name',
                                                                        value:
                                                                          'input',
                                                                      },
                                                                      value: {
                                                                        kind: 'Variable',
                                                                        name: {
                                                                          kind: 'Name',
                                                                          value:
                                                                            'descriptionInput',
                                                                        },
                                                                      },
                                                                    },
                                                                  ],
                                                                },
                                                                {
                                                                  kind: 'Field',
                                                                  name: {
                                                                    kind: 'Name',
                                                                    value:
                                                                      'displayDescription',
                                                                  },
                                                                  arguments: [
                                                                    {
                                                                      kind: 'Argument',
                                                                      name: {
                                                                        kind: 'Name',
                                                                        value:
                                                                          'input',
                                                                      },
                                                                      value: {
                                                                        kind: 'Variable',
                                                                        name: {
                                                                          kind: 'Name',
                                                                          value:
                                                                            'displayDescriptionInput',
                                                                        },
                                                                      },
                                                                    },
                                                                  ],
                                                                },
                                                                {
                                                                  kind: 'Field',
                                                                  name: {
                                                                    kind: 'Name',
                                                                    value:
                                                                      'isSeekMarketCountry',
                                                                  },
                                                                },
                                                                {
                                                                  kind: 'Field',
                                                                  name: {
                                                                    kind: 'Name',
                                                                    value:
                                                                      'country',
                                                                  },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: {
                                                              kind: 'Name',
                                                              value: 'count',
                                                            },
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: {
                                                              kind: 'Name',
                                                              value: 'children',
                                                            },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                {
                                                                  kind: 'Field',
                                                                  name: {
                                                                    kind: 'Name',
                                                                    value:
                                                                      'homeLocation',
                                                                  },
                                                                  selectionSet:
                                                                    {
                                                                      kind: 'SelectionSet',
                                                                      selections:
                                                                        [
                                                                          {
                                                                            kind: 'Field',
                                                                            name: {
                                                                              kind: 'Name',
                                                                              value:
                                                                                'id',
                                                                            },
                                                                          },
                                                                          {
                                                                            kind: 'Field',
                                                                            name: {
                                                                              kind: 'Name',
                                                                              value:
                                                                                'description',
                                                                            },
                                                                            arguments:
                                                                              [
                                                                                {
                                                                                  kind: 'Argument',
                                                                                  name: {
                                                                                    kind: 'Name',
                                                                                    value:
                                                                                      'input',
                                                                                  },
                                                                                  value:
                                                                                    {
                                                                                      kind: 'Variable',
                                                                                      name: {
                                                                                        kind: 'Name',
                                                                                        value:
                                                                                          'descriptionInput',
                                                                                      },
                                                                                    },
                                                                                },
                                                                              ],
                                                                          },
                                                                          {
                                                                            kind: 'Field',
                                                                            name: {
                                                                              kind: 'Name',
                                                                              value:
                                                                                'displayDescription',
                                                                            },
                                                                            arguments:
                                                                              [
                                                                                {
                                                                                  kind: 'Argument',
                                                                                  name: {
                                                                                    kind: 'Name',
                                                                                    value:
                                                                                      'input',
                                                                                  },
                                                                                  value:
                                                                                    {
                                                                                      kind: 'Variable',
                                                                                      name: {
                                                                                        kind: 'Name',
                                                                                        value:
                                                                                          'displayDescriptionInput',
                                                                                      },
                                                                                    },
                                                                                },
                                                                              ],
                                                                          },
                                                                          {
                                                                            kind: 'Field',
                                                                            name: {
                                                                              kind: 'Name',
                                                                              value:
                                                                                'isSeekMarketCountry',
                                                                            },
                                                                          },
                                                                          {
                                                                            kind: 'Field',
                                                                            name: {
                                                                              kind: 'Name',
                                                                              value:
                                                                                'country',
                                                                            },
                                                                          },
                                                                        ],
                                                                    },
                                                                },
                                                                {
                                                                  kind: 'Field',
                                                                  name: {
                                                                    kind: 'Name',
                                                                    value:
                                                                      'count',
                                                                  },
                                                                },
                                                              ],
                                                            },
                                                          },
                                                        ],
                                                      },
                                                    },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'nationalityFacets',
                              },
                              directives: [
                                {
                                  kind: 'Directive',
                                  name: { kind: 'Name', value: 'include' },
                                  arguments: [
                                    {
                                      kind: 'Argument',
                                      name: { kind: 'Name', value: 'if' },
                                      value: {
                                        kind: 'Variable',
                                        name: {
                                          kind: 'Name',
                                          value: 'canShowNationalityFilter',
                                        },
                                      },
                                    },
                                  ],
                                },
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'nationality',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'InlineFragment',
                                          typeCondition: {
                                            kind: 'NamedType',
                                            name: {
                                              kind: 'Name',
                                              value:
                                                'CandidateProfileNationality',
                                            },
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'id',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'countryName',
                                                },
                                                arguments: [
                                                  {
                                                    kind: 'Argument',
                                                    name: {
                                                      kind: 'Name',
                                                      value: 'input',
                                                    },
                                                    value: {
                                                      kind: 'Variable',
                                                      name: {
                                                        kind: 'Name',
                                                        value:
                                                          'candidateProfileNationalityInput',
                                                      },
                                                    },
                                                  },
                                                ],
                                              },
                                            ],
                                          },
                                        },
                                        {
                                          kind: 'InlineFragment',
                                          typeCondition: {
                                            kind: 'NamedType',
                                            name: {
                                              kind: 'Name',
                                              value:
                                                'ApplicationProfileNotSpecifiedNationality',
                                            },
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'id',
                                                },
                                              },
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: 'countryName',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'count' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'statusFacets' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'inboxCount' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'prescreenCount',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'shortlistCount',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'interviewCount',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'offerCount' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'acceptCount',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'rejectedCount',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'newCount' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'totalCount' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'questionnaireAnswerFacets',
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'count' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: {
                                kind: 'Name',
                                value: 'preQuestionnaireFilterTotal',
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ResponseError' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'error' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useApplicationsFacetsQuery__
 *
 * To run a query within a React component, call `useApplicationsFacetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplicationsFacetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplicationsFacetsQuery({
 *   variables: {
 *      applicationsFacetsInput: // value for 'applicationsFacetsInput'
 *      descriptionInput: // value for 'descriptionInput'
 *      displayDescriptionInput: // value for 'displayDescriptionInput'
 *      candidateProfileNationalityInput: // value for 'candidateProfileNationalityInput'
 *      canShowNationalityFilter: // value for 'canShowNationalityFilter'
 *   },
 * });
 */
export function useApplicationsFacetsQuery(
  baseOptions: Apollo.QueryHookOptions<
    ApplicationsFacetsQuery,
    ApplicationsFacetsQueryVariables
  > &
    (
      | { variables: ApplicationsFacetsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    ApplicationsFacetsQuery,
    ApplicationsFacetsQueryVariables
  >(ApplicationsFacetsDocument, options);
}
export function useApplicationsFacetsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ApplicationsFacetsQuery,
    ApplicationsFacetsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    ApplicationsFacetsQuery,
    ApplicationsFacetsQueryVariables
  >(ApplicationsFacetsDocument, options);
}
export function useApplicationsFacetsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        ApplicationsFacetsQuery,
        ApplicationsFacetsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    ApplicationsFacetsQuery,
    ApplicationsFacetsQueryVariables
  >(ApplicationsFacetsDocument, options);
}
export type ApplicationsFacetsQueryHookResult = ReturnType<
  typeof useApplicationsFacetsQuery
>;
export type ApplicationsFacetsLazyQueryHookResult = ReturnType<
  typeof useApplicationsFacetsLazyQuery
>;
export type ApplicationsFacetsSuspenseQueryHookResult = ReturnType<
  typeof useApplicationsFacetsSuspenseQuery
>;
export type ApplicationsFacetsQueryResult = Apollo.QueryResult<
  ApplicationsFacetsQuery,
  ApplicationsFacetsQueryVariables
>;
